import React, { memo } from 'react';
import cls from './WeeksModePosition.module.css';
import classNames from 'classnames';
import { WeekItemPosition } from './WeekItemPosition';
import { useSelector } from 'react-redux';

export const WeeksModePosition = memo(({ position }) => {
    const { weeks } = useSelector((state) => state.gantReducer);

    if (!position) {
        return null;
    }

    return (
        <div className={classNames(cls.DaysModePosition)}>
            <div className={classNames(cls.weeks)}>
                {weeks.map((months) => (
                    <div className={classNames(cls.weeks)} key={Math.random().toString(36)}>
                        {months.weeks.map((item) => (
                            <WeekItemPosition
                                position={position}
                                week={item}
                                isPlanFact={isPlanFact}
                                key={item.title + Math.random().toString(36)}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
});
